export default __webpack_public_path__ + "static/icon_set_one-f047023f55124e9704bab9cedc7ec171.svg";